'use client';

import { useAuth } from 'react-oidc-context';

import type { BlockTemplateBase, RelatedProductRenderer } from '@zoomit/editor';
import type { ArrayElement } from '@zoomit/primitives';
import { useMultipleReviewInfo } from '@zoomit/web-kit';

import RelatedProductSingle from './RelatedProductSingle';

type Props = {
  template: ArrayElement<BlockTemplateBase['related-product']['subTemplates']>['value'];
  blockData: RelatedProductRenderer;
};

const RelatedProductSingleWrapper = (props: Props) => {
  const { blockData, template } = props;
  const { isLoading } = useAuth();

  const { data: reviewData } = useMultipleReviewInfo({
    topicIds: blockData.products.map((p) => p.id),
    topicType: 'Product',
    enabled: !isLoading,
  });

  return <RelatedProductSingle template={template} blockData={blockData} reviewData={reviewData} />;
};

export default RelatedProductSingleWrapper;
